import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getAppPageTitle } from "./NavMenu";

const BRAND = "Great Lawyers";

/** Auth / public routes that are outside the sidebar nav tree. */
const PUBLIC_PAGE_TITLES: { test: RegExp; title: string }[] = [
  { test: /^\/register/, title: "Register" },
  { test: /^\/resetPassword/, title: "Reset password" },
  { test: /^\/generateLink/, title: "Registration link" },
  { test: /^\/attorney-info/, title: "Attorney registration" },
  { test: /^\/login/, title: "Sign in" },
];

function resolveDocumentPageTitle(pathname: string): string {
  const fromApp = getAppPageTitle(pathname);
  if (fromApp) return fromApp;
  for (const entry of PUBLIC_PAGE_TITLES) {
    if (entry.test.test(pathname)) return entry.title;
  }
  return "";
}

export function formatDocumentTitle(pageTitle?: string): string {
  return pageTitle ? `${pageTitle} | ${BRAND}` : BRAND;
}

/** Keeps `document.title` in sync with the current route. */
export default function DocumentTitle() {
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = formatDocumentTitle(
      resolveDocumentPageTitle(pathname) || undefined
    );
  }, [pathname]);

  return null;
}
